import { render, staticRenderFns } from "./children.vue?vue&type=template&id=25335e40&scoped=true"
import script from "./children.vue?vue&type=script&lang=js"
export * from "./children.vue?vue&type=script&lang=js"
import style0 from "./children.vue?vue&type=style&index=0&id=25335e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25335e40",
  null
  
)

export default component.exports